import { Button } from "@mui/joy";
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { Link } from "react-router-dom";

export function ExternalLinkButton({ url, maxWidth = '300px', fullWidth = false, icon = <LaunchOutlinedIcon /> }) {
  return (
    <Link to={url} target="_blank">
      <Button size="sm" variant="outlined" color="neutral" startDecorator={icon} sx={{ width: fullWidth ? '100%' : 'auto', textAlign: 'left' }}>
        <span style={{ maxWidth: fullWidth ? '100%' : maxWidth, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: fullWidth ? '100%' : 'auto' }}>{url}</span>
      </Button>
    </Link>
  );
}
